import { createFileRoute } from "@tanstack/react-router";
import { ErrorAlert } from "@/components/ui";
import { HistorialSolicitudPage } from "@/features/solicitud-historial/components/HistorialSolicitudPage";
import { HistorialSolicitudSkeleton } from "@/features/solicitud-historial/components/HistorialSolicitudSkeleton";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";
import { historialSolicitudQueryOptions } from "@/features/solicitud-historial/hooks/use-historial-solicitud";

/**
 * Historial de cambios de la solicitud · POC v22+ con Temporal Tables.
 *
 * Pre-carga en paralelo:
 *   - La solicitud actual (para el header con folio).
 *   - El historial completo (todas las versiones).
 */
export const Route = createFileRoute("/_authed-tw/solicitudes/$id/historial")({
  loader: ({ context: { queryClient }, params: { id } }) =>
    Promise.all([
      queryClient.ensureQueryData(solicitudQueryOptions(id)),
      queryClient.ensureQueryData(historialSolicitudQueryOptions(id)),
    ]),
  component: HistorialSolicitudPage,
  pendingComponent: HistorialSolicitudSkeleton,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
